import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { useSelector } from "react-redux";
import jsPDF from "jspdf";
import "../scss/PNK.scss";
import Table from "react-bootstrap/Table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Swal from "sweetalert2";
import moment from "moment";

export default ({ item, icons, icon, data, html }) => {
  const { lang, database, proxy } = useSelector((state) => state);
  const { apiGet } = item;
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const _token = localStorage.getItem("_token");

  const fetchData = () => {
    setLoading(true);
    fetch(`${proxy()}${apiGet.api_detail.url}/${data?.MaPXK}`, {
      headers: {
        Authorization: _token,
        "content-type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        const { success, data } = res;
        if (success && data && data.length > 0) {
          setItems(data);
        }
        // handlePDF(data);
      })
      .finally((res) => {
        setLoading(false);
      });
  };

  // useEffect(() => {
  //   if (items && items.length > 0 || data.MaPXK) {
  //     handlePDF();
  //   }
  // }, [items]);

  useEffect(() => {
    let timeout;
    if (loading) {
      Swal.fire({
        title: lang["loading"],
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
    } else {
      timeout = setTimeout(() => {
        Swal.close();
      }, 1000);
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [loading]);

  const handlePDF = (props) => {
    setLoading(true);
    // const totalSoLuong = props.reduce((total, item) => {
    //   const soLuong = Number(item.SoLuong);
    //   return !isNaN(soLuong) ? total + soLuong : total;
    // }, 0);
    // const totalSoBao = props.reduce((total, item) => {
    //   const soBao = Number(item.SoBao);
    //   return !isNaN(soBao) ? total + soBao : total;
    // }, 0);
    const NgayNhapKho = moment(data.NgayNhapKho).format("DD/MM/YYYY");
    const NgayLapPhieu = moment(data.NgayLapPhieu).format("DD/MM/YYYY");

    const TableView = (
      <div
        className="page container pt-5 pl-5 pr-5 pb-0"
        style={{ width: "210mm" }}
      >
        <header className="d-flex">
          <div className="logo">
            <img src="/images/logo/pvcfclogo.png" alt="logo" width="100px" />
          </div>
          <div className="info">
            <p>
              <strong>
                TỔNG CÔNG TY PHÂN BÓN VÀ HÓA CHẤT DẦU KHÍ - CTCP CHI NHÁNH TỔNG
                CÔNG TY PHÂN BÓN VÀ HÓA CHẤT DẦU KHÍ - CTCP - NHÀ MÁY ĐẠM PHÚ MỸ
              </strong>
            </p>

            <p>Địa chỉ: Khu CN Phú Mỹ 1, Phường Phú Mỹ, Thị xã Phú Mỹ</p>
            <p>
              Điện thoại: (+84) 0254 3 921 468 - Fax: (+84) 0254 3 921 477 -{" "}
              <span>
                Website:{" "}
                <a style={{ color: "black" }} href="https://www.dpm.vn">
                  www.dpm.vn
                </a>
              </span>
            </p>
            <p>
              <strong>Mã số thuế: 0303165480 - 001</strong>
            </p>
          </div>
        </header>
        <hr />
        <div class="info">
          <div className="row">
            <div className="col-sm-4"></div>
            <div className="col-sm-4 first d-flex justify-content-center flex-column align-items-center">
              <div>
                <h1 className="font-weight-bold">PHIẾU NHẬP KHO</h1>
              </div>
              <div>(Hàng hóa, thành phẩm)</div>
              <div>
                Số: <span className="font-weight-bold">{data?.MaPNK}</span>
              </div>
              <div>
                Ngày lập phiếu:
                <span className="font-weight-bold">{NgayLapPhieu}</span>
              </div>
            </div>
            <div className="col-sm-4 second d-flex flex-column align-items-end">
              <img
                width={80}
                src={`https://api.qrserver.com/v1/create-qr-code/?data=${data?.MaPNK}`}
                alt="logo"
              />
            </div>
          </div>
          <div className="second d-flex flex-column align-items-end mt-2">
            <div>Số đơn hàng (PO No.):......</div>
            <div>Ngày đơn hàng (PO date):......</div>
          </div>
          <p>
            Ngày nhập: <strong>{NgayNhapKho}</strong>
          </p>
          <p>Họ và tên người giao:</p>
          <p>Đơn vị giao hàng:</p>
          <p>
            Theo: <strong></strong>
          </p>
          <p>
            Nhập tại kho: <strong>{data?.NhapTaiKho}</strong>
          </p>
          <p>
            Địa điểm: <strong>{data?.DiaChiKho}</strong>
          </p>
          <p>
            Lý do nhập: <strong>{data?.LyDoNhapkho}</strong>
          </p>
        </div>
        <table className="mt-3">
          <thead>
            <tr>
              <th>Stt</th>
              <th>
                Tên, nhãn hiệu, quy cách, phẩm chất vật tư, dụng cụ sản phẩm,
                hàng hoá
              </th>
              <th className="align-center">Mã số</th>
              <th className="align-center">Chủng loại vỏ bao</th>
              <th className="align-center">ĐVT</th>
              <th className="align-center">Số lượng</th>
              <th className="align-center">Đơn giá</th>
              <th className="align-center">Thành tiền</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="align-center">1</td>
              <td>{data?.TenSP}</td>
              <td className="align-center">{data?.MaSP}</td>
              <td className="align-center"></td>
              <td className="align-center">Tấn</td>
              <td className="align-center">{data?.SoTan}</td>
              <td className="align-center"></td>
              <td className="align-center"></td>
            </tr>
            <tr>
              <td className="align-center" colSpan={5}>
                Tổng cộng
              </td>
              <td className="align-center">{data.SoTan}</td>
              <td></td>
              <td className="align-center"></td>
            </tr>
          </tbody>
        </table>
        <p className="mt-2">Tổng số tiền (viết bằng chữ): Không đồng</p>
        <footr className="d-flex justify-content-between mt-4">
          <div>
            <strong>Người lập phiếu</strong>
          </div>
          <div>
            <strong>Người giao hàng</strong>
          </div>
          <div>
            <strong>Thủ kho</strong>
          </div>
          <div>
            <strong>Bộ phận có nhu cầu nhập</strong>
          </div>
        </footr>
      </div>
    );

    const element = document.createElement("div");
    ReactDOM.render(TableView, element);
    const doc = new jsPDF({
      orientation: "p",
      format: "a4",
      unit: "px",
      hotfixes: ["px_scaling"],
    });
    doc.addFont(
      "/fonts/Times New Roman/TIMES.ttf",
      "Times New Roman",
      "normal"
    );
    doc.addFont(
      "/fonts/Times New Roman/TIMESBD.ttf",
      "Times New Roman",
      "bold"
    );
    doc.addFont(
      "/fonts/Times New Roman/TIMESI.ttf",
      "Times New Roman",
      "italic"
    );
    doc.setFont("Times New Roman", "italic");
    doc.setFont("Times New Roman", "normal");
    doc.setFont("Times New Roman", "bold");
    doc.html(element, {
      callback: function (doc) {
        // window.open(doc.output("bloburl"), "_blank");
        setLoading(false);
        doc.save(`${data?.MaPNK}.pdf`);
      },
    });
  };
  const date = new Date();
  const month = date.getUTCMonth() + 1;
  const day = date.getUTCDate();
  const year = date.getUTCFullYear();
  const pMonth = month.toString().padStart(2, "0");
  const pDay = day.toString().padStart(2, "0");
  const renderDate = `Ngày ${pDay} tháng ${pMonth} năm ${year}`;

  return (
    // <TableView />
    <div onClick={handlePDF}>
      <FontAwesomeIcon
        icon={icons[icon]?.icon}
        title={item?.title ? item?.title : lang["redirect_button"]}
      />
    </div>
  );
}
